document.addEventListener('DOMContentLoaded', () => {
    const dataEl = document.getElementById('glossary-data');
    if (!dataEl) return;

    let entries;
    try {
        entries = JSON.parse(dataEl.textContent);
    } catch {
        return;
    }

    if (!entries || entries.length === 0) return;

    // Build flat term list: longer terms first to prevent partial-match shadowing
    const terms = [];
    for (const entry of entries) {
        const allTerms = [entry.title, ...entry.keywords].filter(Boolean);
        for (const term of allTerms) {
            const trimmed = term.trim();
            if (trimmed) terms.push({ term: trimmed, entry });
        }
    }
    terms.sort((a, b) => b.term.length - a.term.length);

    if (terms.length === 0) return;

    // Escape special regex characters
    const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    // Use Unicode-aware boundaries instead of \b, because \b in JS only knows
    // ASCII word chars — German umlauts (ü, ä, ö, Ü …) are treated as \W,
    // so \bÜberlebende\b would never match "die Überlebende".
    const wb0 = '(?<![\\p{L}\\p{N}_])';
    const wb1 = '(?![\\p{L}\\p{N}_])';
    let pattern;
    try {
        pattern = new RegExp(
            `${wb0}(${terms.map((t) => escape(t.term)).join('|')})${wb1}`,
            'giu'  // g=global, i=case-insensitive, u=unicode
        );
    } catch (e) {
        console.error('Glossary: failed to build regex', e);
        return;
    }

    // Lookup map: lowercase term → entry
    const termMap = new Map(terms.map((t) => [t.term.toLowerCase(), t.entry]));

    const paragraphs = document.querySelectorAll('.area_content p');
    for (const p of paragraphs) {
        try {
            highlightParagraph(p, pattern, termMap);
        } catch (e) {
            console.error('Glossary: error processing paragraph', p, e);
        }
    }

    setupTooltip();
});

function highlightParagraph(el, pattern, termMap) {
    // Collect text nodes that are not inside links or already-processed triggers
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
            if (node.parentElement?.closest('a, .glossary-trigger, script, style, nav')) {
                return NodeFilter.FILTER_REJECT;
            }
            return NodeFilter.FILTER_ACCEPT;
        },
    });

    const textNodes = [];
    let node;
    while ((node = walker.nextNode())) textNodes.push(node);

    for (const textNode of textNodes) {
        const text = textNode.textContent;
        pattern.lastIndex = 0;
        if (!pattern.test(text)) continue;

        pattern.lastIndex = 0;
        const fragment = document.createDocumentFragment();
        let lastIndex = 0;
        let didReplace = false;
        let match;

        while ((match = pattern.exec(text)) !== null) {
            const entry = termMap.get(match[0].toLowerCase());
            if (!entry) continue;

            didReplace = true;

            // Text before this match
            if (match.index > lastIndex) {
                fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
            }

            // The matched word itself
            fragment.appendChild(document.createTextNode(match[0]));

            // Info-Icon trigger
            fragment.appendChild(createTrigger(entry));

            lastIndex = match.index + match[0].length;
        }

        if (!didReplace) continue;

        // Remaining text after last match
        if (lastIndex < text.length) {
            fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
        }

        textNode.parentNode.replaceChild(fragment, textNode);
    }
}

function createTrigger(entry) {
    const span = document.createElement('span');
    span.className = 'glossary-trigger';
    span.setAttribute('role', 'button');
    span.setAttribute('tabindex', '0');
    span.setAttribute('aria-label', `Glossar: ${entry.title}`);
    span.setAttribute('aria-expanded', 'false');
    span.dataset.glossaryId = entry.id;
    span.dataset.glossaryTitle = entry.title;
    span.dataset.glossaryDescription = entry.description || '';
    span.dataset.glossaryLinkUrl = entry.linkURL || '';
    span.dataset.glossaryLinkTitle = entry.linkTitle || entry.title || '';
    // Info icon (Material Design "info" path)
    span.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
        '<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>' +
        '</svg>';
    return span;
}

function setupTooltip() {
    const tooltip = document.createElement('div');
    tooltip.className = 'glossary-tooltip';
    tooltip.setAttribute('role', 'tooltip');
    tooltip.hidden = true;
    tooltip.innerHTML =
        '<button class="glossary-tooltip__close" aria-label="Schließen">&times;</button>' +
        '<div class="glossary-tooltip__title"></div>' +
        '<div class="glossary-tooltip__description"></div>' +
        '<a class="glossary-tooltip__link" href="#" target="_blank" rel="noopener noreferrer" hidden></a>';
    document.body.appendChild(tooltip);

    const titleEl = tooltip.querySelector('.glossary-tooltip__title');
    const descEl = tooltip.querySelector('.glossary-tooltip__description');
    const linkEl = tooltip.querySelector('.glossary-tooltip__link');
    const closeBtn = tooltip.querySelector('.glossary-tooltip__close');
    let activeTarget = null;

    function show(trigger) {
        titleEl.textContent = trigger.dataset.glossaryTitle || '';
        descEl.textContent = trigger.dataset.glossaryDescription || '';

        const url = trigger.dataset.glossaryLinkUrl;
        if (url) {
            linkEl.href = url;
            linkEl.textContent = trigger.dataset.glossaryLinkTitle || trigger.dataset.glossaryTitle;
            linkEl.hidden = false;
        } else {
            linkEl.hidden = true;
        }

        tooltip.hidden = false;
        positionTooltip(trigger);
        activeTarget = trigger;
        trigger.setAttribute('aria-expanded', 'true');
    }

    function hide() {
        tooltip.hidden = true;
        if (activeTarget) {
            activeTarget.setAttribute('aria-expanded', 'false');
            activeTarget = null;
        }
    }

    function positionTooltip(trigger) {
        const rect = trigger.getBoundingClientRect();
        const tooltipWidth = 280;
        let left = rect.left + window.scrollX;

        if (left + tooltipWidth > window.innerWidth - 10) {
            left = window.innerWidth - tooltipWidth - 10;
        }
        left = Math.max(10, left);

        tooltip.style.left = left + 'px';
        tooltip.style.top = rect.bottom + window.scrollY + 8 + 'px';
    }

    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('.glossary-trigger');
        if (trigger) {
            e.stopPropagation();
            activeTarget === trigger ? hide() : show(trigger);
            return;
        }
        if (!tooltip.contains(e.target)) hide();
    });

    closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        hide();
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            hide();
            return;
        }
        if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('.glossary-trigger')) {
            e.preventDefault();
            const trigger = e.target.closest('.glossary-trigger');
            activeTarget === trigger ? hide() : show(trigger);
        }
    });
}
